<template>
  <div v-loading.fullscreen.lock="loading" class="register">
    <div class="register-img">
      <span>HI~</span>
      <span
        class="register-title"
      >郑州市中小学实验室智能整合系统邀请您成为{{ school_name }}管理员！</span
      >
    </div>
    <div class="register-form">
      <div v-if="isShow == false">
        <img
          :src="require(`@/assets/dto/dto-login2.png`)"
          alt=""
          class="toQrCode"
          @click="toQrCode"
        >
        <div class="denglu">
          注册
        </div>
        <el-scrollbar wrap-style="overflow-x: hidden;">
          <el-form
            ref="info"
            :model="info"
            :rules="systemInfo.obj.rules1"
            status-icon
            label-position="left"
            label-width="0px"
          >
            <el-form-item prop="phone">
              <el-input
                v-model="info.phone"
                type="text"
                auto-complete="off"
                placeholder="输入手机号"
                clearable
              />
            </el-form-item>
            <el-form-item class="btn4">
              <el-input
                v-model="info1.captcha"
                type="smsCheck"
                auto-complete="off"
                placeholder="验证码"
                clearable
              />
              <el-button type="text">
                <img :src="imgUrl" alt="" @click="handleCheckImg">
              </el-button>
            </el-form-item>
            <el-form-item prop="code" class="btn4">
              <el-input
                v-model="info.code"
                type="smsCheck"
                auto-complete="off"
                placeholder="输入验证码"
                clearable
              />
              <el-button
                :disabled="info.phone.length != 11 || isSendCode"
                class="btn3"
                @click="getVerificationCode"
              >
                {{ codeText }}
              </el-button>
            </el-form-item>

            <el-button
              type="primary"
              class="btn1"
              :loading="logining"
              @click="handleSubmit"
            >
              注册
            </el-button
            >
            <div class="other">
              已有账号去<span @click="handleRoute('/login')">登录</span>
            </div>
            <div class="other apply">
              学校<span @click="handleRoute('/apply')">申请</span>
            </div>
          </el-form>
        </el-scrollbar>
      </div>
      <div v-else>
        <img
          :src="require(`@/assets/dto/dto-login1.png`)"
          alt=""
          class="toQrCode"
          @click="to222form"
        >
        <iframe
          :src="this.urltest"
          frameborder="0"
          width="100%"
          height="400px"
          scrolling="auto"
        />
      </div>
    </div>
  </div>
</template>

<script src="https://res.wx.qq.com/connect/zh_CN/htmledition/js/wxLogin.js"></script>

<script>
import api from "@/api/app";
import mock from "@/utils/mock";
import { setTokenExp } from "@/utils/auth";
export default {
  components: {},
  data() {
    return {
      isShow: false,
      dialogVisible1: false,
      systemInfo: mock.system.register.viewInfo,
      systemInit: mock.system.register.init,
      logining: false,
      loading: false,
      isSendCode: false,
      codeText: "发送验证码",
      imgUrl: null,
      info: {
        phone: "",
        code: "",
        school_id: "1",
        encryption: "1",
        avatar: "",
      },
      school_name: "",
      info1: {
        phone: null,
        captcha: null,
        key: null,
      },
      appid: "",
      redirect_uri: "",
      scope: "",
      state: "",
      code: "",
      urltest: "",
      param: {
        type: 1,
        school_id: "",
        encryption: "",
      },
    };
  },
  created() {
    this.handleCheckImg();
    if (this.$route.query.school_id) {
      this.loading = true;
      this.info.school_id = this.$route.query.school_id;
      this.init({ school_id: this.info.school_id });
    }
    if (this.$route.query.encryption) {
      this.info.encryption = this.$route.query.encryption;
    }
    if (this.$route.query.school_name) {
      this.school_name = this.$route.query.school_name;
    }
    let _this = this;
    document.onkeydown = function (e) {
      var key = window.event.keyCode;
      if (key == 13) {
        _this.handleSubmit();
      }
    };
  },
  mounted() {},

  methods: {
    to222form() {
      this.isShow = false;
    },
    toQrCode() {
      this.isShow = true;
      this.handleWxRegister();
    },
    handleWxRegister() {
      this.dialogVisible1 = true;
      this.param.school_id = this.$route.query.school_id;
      this.param.encryption = this.$route.query.encryption;
      api.system.wx(this.param).then((res) => {
        let APPID = res.data.appid;
        let REDIRECT_URI = res.data.redirect_uri;
        let STATE = res.data.state;
        this.urltest = `https://open.weixin.qq.com/connect/qrconnect?appid=${APPID}&redirect_uri=${REDIRECT_URI}&response_type=code&scope=snsapi_login&state=${STATE}#wechat_redirect`;
        var obj = new WxLogin({
          self_redirect: false,
          id: "login_container",
          appid: APPID,
          scope: "snsapi_login",
          redirect_uri: REDIRECT_URI,
          state: STATE,
          style: "black",
          href: "data:text/css;base64,LmltcG93ZXJCb3ggLm5vcm1hbFBhbmVse21hcmdpbi10b3A6IDE1cHg7fQouaW1wb3dlckJveCAucXJjb2RlIHt3aWR0aDogMjMwcHg7Ym9yZGVyLWNvbG9yOiNDNUUxRkY7fQouaW1wb3dlckJveCAudGl0bGUge2Rpc3BsYXk6IG5vbmU7fQ==",
        });
      });
    },
    async init(v) {
      this.school_name = await this.systemInit.name(v);
      this.loading = false;
    },
    async handleCheckImg() {
      let obj = await this.systemInit.handleCheckImg();
      this.imgUrl = obj.img;
      this.info1.key = obj.key;
    },
    getVerificationCode() {
      this.info1.phone = this.info.phone;
      if (this.info1.captcha) {
        api.system.sendSms(this.info1).then(() => {
          this.$message({
            message: "验证码已发送",
            type: "success",
          });
          this.countDown(60);
        });
      } else {
        this.$message({
          message: "请正确填写图片验证码",
          type: "error",
        });
      }
    },
    countDown(time) {
      if (time === 0) {
        this.isSendCode = false;
        this.codeText = "发送验证码";
        return;
      } else {
        this.isSendCode = true;
        this.codeText = "重新发送(" + time + ")";
        time--;
      }
      setTimeout(() => {
        this.countDown(time);
      }, 1000);
    },
    async handleSubmit() {
      if (this.info1.captcha && this.info.code && this.info.phone) {
        api.system.register(this.info).then((res) => {
          this.$message({
            message: "注册成功",
            type: "success",
          });
          setTokenExp(res.data.token, res.data.expires_in);
          api.mine.retrieve.dto({ token: res.data.token }).then((v) => {
            setTimeout(() => {
              localStorage.setItem("user", JSON.stringify(v.data));
              this.$store.commit("user/setUser", v.data);
              this.$router.push({ path: "/" });
            }, 1000);
          });
        });
      } else {
        this.$message({
          message: "请填写完整",
          type: "error",
        });
      }
    },
    handleRoute(v) {
      this.$router.push(v);
    },
  },
};
</script>

<style scoped lang="scss">
.toQrCode {
  position: absolute;
  right: 0;
  top: 0;
  border-top-right-radius: 30px;
}
.btn3 {
  border-radius: 30px !important;
  color: #5282f0;
  border-color: #5282f0;
}
.btn1 {
  width: 216px;
  height: 53px;
  margin: 0 19%;
  margin-top: 7%;
  background-image: linear-gradient(24deg, #5f8cf4 0%, #5181ef 100%),
    linear-gradient(#2eae3d, #2eae3d);
  background-blend-mode: normal, normal;
  box-shadow: 0px 10px 19px 2px rgba(82, 130, 240, 0.24);
  border-radius: 26px;
  border: 0;
  color: #ffffff;
  font-family: "Adobe Heiti Std";
  font-size: 18px;
  text-align: center;
}
.register {
  display: flex;
  overflow: hidden;
  height: 100vh;
  display: flex;
  background: url("../../../assets/bg/bg-system2.png") no-repeat;
  background-size: 100% 100%;
  &-img {
    width: 50%;
    height: 100%;
    padding: 2.46% 0 0 3.8%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    position: relative;
    > span {
      position: absolute;
      top: 5%;
      font-size: 24px;
      color: #fff;
    }
    .register-title {
      top: 10%;
    }
  }
  &-form {
    width: 50%;
    flex: 1;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    > div {
      height: 60%;
      width: 485px;
      @include fun-layout(2);
      padding: 9% 7% 6.7% 6.7%;
      border-radius: 30px;
      position: relative;
      > div {
        &:nth-child(2) {
          font-size: 22px;
          color: #5282f0;
          margin-bottom: 20px;
          font-weight: bold;
          font-family: "Microsoft Ya Hei";
        }
      }
      .other {
        margin-top: 7%;
        text-align: center;
        font-family: AdobeHeitiStd-Regular;
        font-size: 14px;
        color: #888;
        > span {
          cursor: pointer;
          color: #5e8cf4;
        }
      }
    }
  }
}
</style>
<style scoped lang="scss">
.register-form /deep/.el-form-item {
  margin-bottom: 16px;
}
.register-form /deep/ .el-input__inner {
  -webkit-appearance: none;
  background-color: #fff;
  background-image: none;
  border-radius: 0;
  width: 100%;
  height: 55px;
  @include fun-border(0, "bottom");
}
.btn4 /deep/ .el-form-item__content {
  display: flex;
  > div {
    width: 60%;
    margin-right: 10%;
  }
  button {
    padding: 0;
    width: 30%;
    border-radius: 6px;
    img {
      height: 55px;
      width: 100%;
    }
  }
}
.register-form /deep/ .el-form-item__error {
  left: 15px;
}
.btn3 /deep/ .el-button:focus,
.el-button:hover {
  background-color: #ecf5ff;
}
</style>
